import useDumbPageTitle from "hooks/useDumbPageTitle";
import { Divider } from "@mui/material";
import { RoleManagementSection } from "components/Settings/RoleManagementSection";
import { EnabledFeaturesSection } from "components/Settings/EnabledFeaturesSection";
import { PowerBISettingsSection } from "components/Settings/PowerBISettingsSection";
import { PowerFactorsSettingsSection } from "components/Settings/PowerFactorsSettingsSection";
import { EntitlementManagementSection } from "components/Settings/EntitlementManagementSection";
import { ComponentsSection } from "components/Settings/ComponentsSection";
import { styled } from "@mui/material/styles";
import { ScalarConfigurationSection } from "components/Settings/ScalarConfigurationSection";
import { MachineModelSection } from "components/Settings/MachineModelSection";
import { MachinesSection } from "components/Settings/MachinesSection";
import { ManufacturersSection } from "components/Settings/ManufacturersSection";
import { TagsSection } from "components/Settings/TagsSection";
import { PropTypes } from "prop-types";
import { UserManagementSection } from "pages/settings/UserManagementSection";
import { EmailScheduleSettingsSection } from "pages/settings/EmailScheduleSettingsSection";
import { IntegrationUserSettingsSection } from "pages/settings/IntegrationUserSettingsSection";
import { UsersProvider } from "contexts/UsersContext";

export function SettingsPage() {
  useDumbPageTitle("Settings");
  return (
    <>
      <Header title="Instance Settings" />
      <EnabledFeaturesSection />
      <UsersProvider>
        <IntegrationUserSettingsSection />
      </UsersProvider>
      <PowerBISettingsSection />
      <EmailScheduleSettingsSection />
      <PowerFactorsSettingsSection />
      <Header title="User and Permissions Management" />
      <UserManagementSection />
      <RoleManagementSection />
      <EntitlementManagementSection />
      <Header title="System Configuration" />
      <ScalarConfigurationSection />
      <ManufacturersSection />
      <MachineModelSection />
      <MachinesSection />
      <ComponentsSection />
      <TagsSection />
    </>
  );
}

const SectionHeader = styled("h3")`
  padding: ${({ theme }) => theme.spacing(1)};
  margin: 0px;
  text-align: center;
`;

const StyledDivider = styled(Divider)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

function Header({ title }) {
  return (
    <>
      <StyledDivider />
      <SectionHeader>{title}</SectionHeader>
      <StyledDivider />
    </>
  );
}

Header.propTypes = {
  title: PropTypes.string
};
